// src/store.ts
import { create } from 'zustand';

/**
 * Interface for authentication state
 */
interface navbarState {
    selectedNav: string;
    setSelectedNav: (selectedNav: string) => void;
}

/**
 * Zustand store for authentication
 */
export const useNavbarStore = create<navbarState>((set) => ({
    selectedNav: "tablero",
    setSelectedNav: (selectedNav) => set({ selectedNav }),
}));